import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCreateConversation = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 13" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#007AFF"
        strokeLinecap="round"
        d="m7 1.523 5.931 5 6.069-5"
      />
      <g fill="#007AFF">
        <path d="M2.4 3h1v6h-1z" />
        <path d="M6 5.4v1H0v-1z" />
      </g>
      <g stroke="#007AFF">
        <path d="M7.022.523H19a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V10" />
        <path d="M8.708.523H7a1 1 0 0 0-1 1V3" />
      </g>
    </g>
  </svg>
);
const Memo = memo(SvgCreateConversation);
export default Memo;
